import { SortResultType } from '../interface/interface';

export const sort: SortResultType = (a, b, isAscending) => {
  if (a > b) return isAscending ? 1 : -1;
  if (a < b) return isAscending ? -1 : 1;
  return 0;
};
